<template>
  <div class="pa-4">
    <div>
      <div>{{ index }}. {{ question.title }}</div>
      <div style="font-size: 12px">{{ question.countReply || 0 }} câu trả lời</div>
    </div>

    <div class="mt-4">
      <v-card>
        <v-data-table :headers="headers" :items="items" :items-per-page="5" disable-sort>
          <template v-slot:[`item.student`]="{ item }">
            <CardStudentName :student="item.student" link />
          </template>
          <template v-slot:[`item.class`]="{ item }">
            <router-link style="text-decoration: none" :to="'/class/' + get(item, 'student.currentClass.id', '')">
              <span v-if="get(item, 'student.currentClass')">{{ get(item, 'student.currentClass.title', '') }}</span>
            </router-link>
          </template>
          <template v-slot:[`item.answer`]="{ item }">
            <span>{{ item.answer }}</span>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
import CardStudentName from '@/components/basic/card/CardStudentName'
export default {
  components: { CardStudentName },
  props: {
    question: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      get,
      headers: [
        { text: 'Học sinh', width: '250px', value: 'student' },
        { text: 'Lớp', width: '100px', value: 'class' },
        { text: 'Trả lời', value: 'answer' }
      ],
      items: []
    }
  },
  watch: {
    question: {
      handler() {
        this.items = this.question.answers
      },
      immediate: true
    }
  }
}
</script>

<style></style>
